module.exports = __webpack_public_path__ + "img/logo-white.ca18911a.png";